import React from 'react';

const SuccessIcon = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="12" fill="#12A676"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M17.4697 6.96967C17.7626 6.67678 18.2373 6.67678 18.5302 6.96967C18.8231 7.26257 18.8231 7.73734 18.5302 8.03022L10.2802 16.2802C9.98734 16.5731 9.51257 16.5731 9.21967 16.2802L5.46967 12.5302C5.17678 12.2373 5.17678 11.7626 5.46967 11.4697C5.76256 11.1768 6.23732 11.1768 6.53022 11.4697L9.74994 14.6894L17.4697 6.96967Z" fill="#333333"/>
  </svg>
);

export default SuccessIcon;
